import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";

import { CompanyFacadeService } from "../services/company-facade.service";
import { NavigationFacadeService } from "../services/navigation-facade.service";

@Injectable()
export class LoadApplicationGuard {
	private loadUrlRegExp = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";

	constructor(
		private navigationFacade: NavigationFacadeService,
		private companyFacade: CompanyFacadeService,
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		const orgUuid = route.params["orgUuid"];

		if (!orgUuid.match(new RegExp(this.loadUrlRegExp, "gi"))) {
			this.navigationFacade.go({ path: ["/"] });
			return false;
		}

		if (
			!this.companyFacade.organizationInfo ||
			Object.keys(this.companyFacade.organizationInfo).length === 0
		) {
			this.navigationFacade.go({ path: ["/"] });
			return false;
		}

		return true;
	}
}
